import React from 'react';
import ExpandableContent from '../../components/ExpandableContent';

function PainPostCard({
    post,
    handleExtractPains,
    extractingPains,
    openPainExpanderPermalink
}) {
    const sanitizedPermalink = post.permalink.replace(/[^a-zA-Z0-9]/g, '_');
    const isExpanded = openPainExpanderPermalink === post.permalink;

    return (
        <div className="bg-[var(--background-color-card)] p-6 rounded-xl border border-[var(--color-border-subtle)] shadow-sm">
            <h3 className="font-semibold text-[var(--color-text-primary)] text-lg mb-2">
                <a href={post.permalink} target="_blank" rel="noopener noreferrer" className="hover:underline" data-testid="painPostCard-postTitleLink">
                    {post.title}
                </a>
            </h3>

            <p className="text-sm text-[var(--color-text-secondary)] mb-4">
              Created by <a href={`https://www.reddit.com/user/${post.author}`} target="_blank" rel="noopener noreferrer" className="font-medium hover:underline" data-testid="painPostCard-postAuthorLink">{post.author}</a>
              {post.score !== undefined && (
                <span className="ml-2"> • Score: {post.score}</span>
              )}
              {post.num_comments !== undefined && (
                <span className="ml-2"> • Comments: {post.num_comments}</span>
              )}
            </p>

            <div className="prose prose-sm dark:prose-invert max-w-none mb-4">
                <ExpandableContent content={post.selftext} />
            </div>

            <div className="mt-4">
                <button 
                  id={`extract-pains-button-${sanitizedPermalink}`}
                  className="bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={() => handleExtractPains(post)}
                  disabled={extractingPains.has(post.permalink)}
                  data-testid="painPostCard-extractPainsButton"
                >
                  {extractingPains.has(post.permalink) ? (
                    <div className="spinner w-5 h-5 border-2"></div>
                  ) : (
                    <>
                        <span className="material-symbols-outlined text-base">
                            {isExpanded ? 'close' : 'psychology'}
                        </span>
                        {isExpanded ? 'Hide Pains' : 'Show Pains'}
                    </>
                  )}
                </button>
            </div>
        </div>
    );
}

export default PainPostCard;
